import { allpeepNoPayloadEndpoint, allpeepPayloadEndpoint } from './helpers.js';
export const payments = (rawClient) => ({
    createCheckout: allpeepNoPayloadEndpoint(rawClient, '/payments/create-checkout', 'post'),
    createPortal: allpeepNoPayloadEndpoint(rawClient, '/payments/create-portal', 'post'),
    success: allpeepNoPayloadEndpoint(rawClient, '/payments/success'),
    status: allpeepNoPayloadEndpoint(rawClient, '/payments/status'),
    test: allpeepPayloadEndpoint(rawClient, '/payments/test'),
});
